/**
 * @prettier
 */
export function isEmail(email?: string): boolean {
    if (!email) return false;
    return /(?:(^\S+@\S+\.\S+$)|(^\s*$))/.test(email);
}
